import React, { forwardRef } from 'react';
import { CaretDown } from '@phosphor-icons/react';
import { cn } from '../../lib/utils';
export interface SelectOption {
  value: string;
  label: string;
}
export interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'options'> {
  label?: string;
  error?: string;
  options: SelectOption[];
  placeholder?: string;
}
const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  className,
  label,
  error,
  options,
  placeholder,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-2841">
        {label && <label className="mb-2 block text-sm font-medium text-foreground" data-id="element-2842">
            {label}
          </label>}
        <div className="relative" data-id="element-2843">
          <select className={cn('flex h-10 w-full appearance-none rounded-md border border-input bg-background px-3 pr-10 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50', error && 'border-destructive focus-visible:ring-destructive', className)} ref={ref} {...props} data-id="element-2844">
            {placeholder && <option value="" disabled data-id="element-2845">
                {placeholder}
              </option>}
            {options.map(option => <option key={option.value} value={option.value} data-id="element-2846">
                {option.label}
              </option>)}
          </select>
          <CaretDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-light-3" weight="bold" data-id="element-2847" />
        </div>
        {error && <p className="mt-1 text-sm text-destructive" data-id="element-2848">{error}</p>}
      </div>;
});
Select.displayName = 'Select';
export { Select };